import { createStore, applyMiddleware, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './ducks/rootSaga';
import rootReducer from './ducks/rootReducer';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import { MovimentacoesState } from './ducks/movimentacoes/types';
import { SolicitacoesRetornoState } from './ducks/solicitacoesRetorno/types';
import { AuthState } from './ducks/auth/types';
import { EstoqueState } from './ducks/estoque/types';
import { EstoqueCartState } from './ducks/estoqueCart/types';
import { TransportadorasState } from './ducks/transportadoras/types';
import { SolicitacaoRetornoState } from './ducks/solicitacaoRetorno/types';
import { SolicitacoesRetornoItensNotaState } from './ducks/solicitacoesRetornoItensNota/types';
import { MotoristaState } from './ducks/motorista/types';
import { ProdutosState } from './ducks/produtos/types';
import { ColetaNoCdState } from './ducks/coletaNoCd/types';
import { PagadorArmazenagemState } from './ducks/pagadorArmazenagem/types';
import { AgendamentosState } from './ducks/agendamentos/types';
import { FornecedorState } from './ducks/fornecedor/types';
import { CentrosDistribuicaoState } from './ducks/centrosDistribuicao/types';
import { PedidoEntregaState } from './ducks/pedidoEntrega/types';
import { CidadeOrigemState } from './ducks/cidadeOrigem/types';
import { EntregaNoCdState } from './ducks/entregaNoCd/types';
import { ListarVeiculosState } from './ducks/listarVeiculos/types';
import { TomadoresTransportadoraState } from './ducks/tomadoresTransportadora/types';
import { OrdemCargaState } from './ducks/ordemCarga/types';
import { EstadoCidadeState } from './ducks/estadoCidade/types';
import { CriaAgendamentoState } from './ducks/criaAgendamento/types';
import { DataHoraordemDeCargaState } from './ducks/dataHoraordemDeCarga/types';
import { DetalheVeiculoState } from './ducks/detalheVeiculo/types';
import { PlataformaState } from './ducks/plataforma/types';
import { EstadoOrigemState } from './ducks/estadoOrigem/types';
import { OrdemCargaPageState } from './ducks/ordemCargaPage/types';
import { AtendimentosState } from './ducks/atendimentos/types';
import { CriarAtendimentoState } from './ducks/criarAtendimento/types';
import { AtendimentosMensagensState } from './ducks/sendMenssages/types';
import { ConsultaAgendamentosState } from './ducks/consultaAgendamentos/types';
import { AgrupamentosState } from './ducks/agrupamento/types';
import { SemaphoreState } from './ducks/semaphore/types';
import { KpiACState } from './ducks/kpiAC/types';
import { KpiEAIState } from './ducks/kpiEAI/types';
import { KpiEAEState } from './ducks/kpiEAE/types';
import { KpiSAState } from './ducks/kpiSA/types';
import { KpiSEState } from './ducks/kpiSE/types';
import { OcorrenciaState } from './ducks/ocorrencia/types';
import { ProgressBarSLAState } from './ducks/progressBarSLA/types';
import { NotificationsState } from './ducks/notifications/types';
import { DashSlaState } from './ducks/dashSlaAtendimento/types';
import { TrackingState } from './ducks/tracking/types';
import { BlackListState } from './ducks/blackList/types';
import { CargaDescargaState } from './ducks/cargaDescarga/types';
import { HorariosDisponiveisState } from './ducks/horariosDisponiveis/types';
import { DetalhesOrdemCargaState } from './ducks/detalhesOrdemCarga/types';
import { DepositanteState } from './ducks/depositante/types';

export interface ApplicationState {
  auth: AuthState;
  Movimentacoes: MovimentacoesState;
  SolicitacoesRetorno: SolicitacoesRetornoState;
  Estoque: EstoqueState;
  Produtos: ProdutosState;
  EstoqueCart: EstoqueCartState;
  ColetaNoCd: ColetaNoCdState;
  EntregaNoCd: EntregaNoCdState;
  Transportadoras: TransportadorasState;
  SolicitacaoRetorno: SolicitacaoRetornoState;
  SolicitacoesRetornoItensNota: SolicitacoesRetornoItensNotaState;
  Motorista: MotoristaState;
  Fornecedor: FornecedorState;
  CentrosDistribuicao: CentrosDistribuicaoState;
  PagadorArmazenagem: PagadorArmazenagemState;
  CidadeOrigem: CidadeOrigemState;
  EstadoOrigem: EstadoOrigemState;
  Agendamentos: AgendamentosState;
  TomadoresTransportadora: TomadoresTransportadoraState;
  PedidoEntrega: PedidoEntregaState;
  ListarVeiculos: ListarVeiculosState;
  OrdemCarga: OrdemCargaState;
  OrdemCargaPage: OrdemCargaPageState;
  EstadoCidade: EstadoCidadeState;
  CriaAgendamento: CriaAgendamentoState;
  DataHoraordemDeCarga: DataHoraordemDeCargaState;
  DetalheVeiculo: DetalheVeiculoState;
  Plataforma: PlataformaState;
  Atendimentos: AtendimentosState;
  CriarAtendimento: CriarAtendimentoState;
  AtendimentoMensagens: AtendimentosMensagensState;
  ConsultaAgendamentos: ConsultaAgendamentosState;
  Agrupamentos: AgrupamentosState;
  Semaphore: SemaphoreState;
  KPIAC: KpiACState;
  KPIEAI: KpiEAIState;
  KPIEAE: KpiEAEState;
  KPISA: KpiSAState;
  KPISE: KpiSEState;
  Ocorrencia: OcorrenciaState;
  ProgressBarSLA: ProgressBarSLAState;
  Notifications: NotificationsState;
  DashSla: DashSlaState;
  Tracking: TrackingState;
  BlackList: BlackListState;
  CargaDescarga: CargaDescargaState;
  HorariosDisponiveis: HorariosDisponiveisState;
  DetalhesOrdemCarga: DetalhesOrdemCargaState;
  Depositante: DepositanteState;
}

export interface PersistConfig {
  key: string;
  storage: typeof storage;
  whitelist: string[];
}

const persistConfig: PersistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'EstoqueCart',
    'Movimentacoes',
    'Estoque',
    'SolicitacoesRetorno',
    'EntregaNoCd',
    'ColetaNoCd',
    'OrdemCarga',
    'OrdemCargaPage',
    'Agendamentos',
    'DashSla',
    'CargaDescarga',
    'Motorista',
    'ListarVeiculos',
    'Blacklist',
    'Tracking',
    'Atendimentos',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleare = createSagaMiddleware();

const store: Store<ApplicationState> = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleare))
);

const persistor = persistStore(store);

sagaMiddleare.run(rootSaga);
export { store, persistor };
